export default {
      id: "ic_clear-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_clear",
      toString: function () {
        return this.url;
      }
    }